// Default VAT rate (Regelsteuersatz § 12 Abs. 1 UStG) for new invoices and offers
export const taxValue = 19;
